import React, { useState } from "react";
import Head from "../components/Head";
import Foot from "../components/Foot";
import axios from "axios";
const apiUrl = process.env.REACT_APP_API_URL;
function Register() {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    aadhar_no: "",
    mobile: "",
    email: "",
    postcode: "",
    country: "",
    main_tel: "",
    website: "",
    address: "",
    degree: "",
    engineering: "",
    guardian_first_name: "",
    guardian_last_name: "",
    guardian_job_title: "",
    guardian_telephone: "",
    guardian_mobile: "",
    guardian_email: "",
    courses: [],
    course_other_text: "",
    date: "",
  });
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      const updatedCourses = [...formData.courses];
      if (checked) {
        updatedCourses.push(value);
      } else {
        const index = updatedCourses.indexOf(value);
        if (index > -1) updatedCourses.splice(index, 1);
      }
      setFormData({ ...formData, courses: updatedCourses });
      if (value === "Other" && checked) {
        setFormData({ ...formData, course_other_text: "" });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess("");
    setError("");
    try {
      const response = await axios.post(`${apiUrl}/api/register`, formData);
      if (response.data.success) {
        setSuccess("Registration submitted successfully!");
        setFormData({
          first_name: "",
          last_name: "",
          aadhar_no: "",
          mobile: "",
          email: "",
          postcode: "",
          country: "",
          main_tel: "",
          website: "",
          address: "",
          degree: "",
          engineering: "",
          guardian_first_name: "",
          guardian_last_name: "",
          guardian_job_title: "",
          guardian_telephone: "",
          guardian_mobile: "",
          guardian_email: "",
          courses: [],
          course_other_text: "",
          date: "",
        });
      } else {
        setError(response.data.message || "Failed to submit registration.");
      }
    } catch (err) {
      setError(err.response?.data?.message || "Error submitting registration.");
    }
  };
  return (
    <>
      <Head />
      {/* Strat Contact */}
      <div className="ak-height-125 ak-height-lg-80" />
      <div className="container px-md-0">
        <div className="contact-form-content">
          <div className="contact-form maxwid" style={{ marginTop: 100 }}>
            <div>
              <h2>Register Now</h2>
              <h5 className="contact-title">
                Ready to elevate your career in Facilities &amp; Professional
                Management? Our expert team is here to guide you with global
                certifications, practical training, and personalized support.
                Fill out the form below and let’s start your journey.
              </h5>
              <div className="ak-height-40 ak-height-lg-30" />
            </div>
            {success && <div className="alert alert-success mb-16">{success}</div>}
            {error && <div className="alert alert-danger mb-16">{error}</div>}
            <form onSubmit={handleSubmit}>
              {/* Student Details */}
              <div>
                <h3 className="contact-title ak-mb-20">Student Details</h3>
                <div className="form-inputs">
                  <div className="type_1">
                    <label htmlFor="first_name" className="form-label">
                      First Name
                    </label>
                    <input
                      type="text"
                      name="first_name"
                      id="first_name"
                      className="csame"
                      placeholder="Write your first name here..."
                      value={formData.first_name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="type_1">
                    <label htmlFor="last_name" className="form-label">
                      Last Name
                    </label>
                    <input
                      type="text"
                      name="last_name"
                      id="last_name"
                      className="csame"
                      placeholder="Write your last name here..."
                      value={formData.last_name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="form-inputs">
                  <div className="type_1">
                    <label htmlFor="aadhar_no" className="form-label">
                      Aadhar No.
                    </label>
                    <input
                      type="text"
                      name="aadhar_no"
                      id="aadhar_no"
                      className="csame"
                      placeholder="Write your aadhar number here..."
                      value={formData.aadhar_no}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="type_1">
                    <label htmlFor="mobile" className="form-label">
                      Mobile
                    </label>
                    <input
                      type="tel"
                      name="mobile"
                      id="mobile"
                      className="csame"
                      placeholder="Write your mobile number here..."
                      value={formData.mobile}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>
                <div className="form-inputs">
                  <div className="type_1">
                    <label htmlFor="email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      name="email"
                      id="email"
                      className="csame"
                      placeholder="Write your email here..."
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="type_1">
                    <label htmlFor="postcode" className="form-label">
                      Postcode
                    </label>
                    <input
                      type="text"
                      name="postcode"
                      id="postcode"
                      className="csame"
                      placeholder="Write your postcode here..."
                      value={formData.postcode}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-inputs">
                  <div className="type_1">
                    <label htmlFor="country" className="form-label">
                      Country
                    </label>
                    <input
                      type="text"
                      name="country"
                      id="country"
                      className="csame"
                      placeholder="Write your country here..."
                      value={formData.country}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="type_1">
                    <label htmlFor="main_tel" className="form-label">
                      Main Telephone No.
                    </label>
                    <input
                      type="tel"
                      name="main_tel"
                      id="main_tel"
                      className="csame"
                      placeholder="Write your main telephone here..."
                      value={formData.main_tel}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-inputs">
                  <div className="type_1">
                    <label htmlFor="website" className="form-label">
                      Website URL
                    </label>
                    <input
                      type="url"
                      name="website"
                      id="website"
                      className="csame"
                      placeholder="Write your website URL here..."
                      value={formData.website}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-textarea">
                  <div className="type_1">
                    <label htmlFor="address" className="form-label">
                      Address
                    </label>
                    <textarea
                      name="address"
                      rows={4}
                      id="address"
                      className="csame"
                      placeholder="Write your address here..."
                      value={formData.address}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-inputs">
                  <div className="type_1">
                    <label className="form-label">Degree</label>
                    <div className="ak-display-flex ak-gap-20 ak-align-center">
                      <label className="ak-cursor-pointer">
                        <input
                          type="radio"
                          name="degree"
                          value="Yes"
                          className="ak-mr-5"
                          checked={formData.degree === "Yes"}
                          onChange={handleChange}
                        />{" "}
                        Yes
                      </label>
                      <label className="ak-cursor-pointer">
                        <input
                          type="radio"
                          name="degree"
                          value="No"
                          className="ak-mr-5"
                          checked={formData.degree === "No"}
                          onChange={handleChange}
                        />{" "}
                        No
                      </label>
                    </div>
                  </div>
                  <div className="type_1">
                    <label className="form-label">Engineering</label>
                    <div className="ak-display-flex ak-gap-20 ak-align-center">
                      <label className="ak-cursor-pointer">
                        <input
                          type="radio"
                          name="engineering"
                          value="Yes"
                          className="ak-mr-5"
                          checked={formData.engineering === "Yes"}
                          onChange={handleChange}
                        />{" "}
                        Yes
                      </label>
                      <label className="ak-cursor-pointer">
                        <input
                          type="radio"
                          name="engineering"
                          value="No"
                          className="ak-mr-5"
                          checked={formData.engineering === "No"}
                          onChange={handleChange}
                        />{" "}
                        No
                      </label>
                    </div>
                  </div>
                </div>
                <div className="ak-height-40 ak-height-lg-30" />
              </div>
              {/* Guardian Details */}
              <div>
                <h3 className="contact-title ak-mb-20">Father/Mother/Guardian Contact</h3>
                <div className="form-inputs">
                  <div className="type_1">
                    <label htmlFor="guardian_first_name" className="form-label">
                      First Name
                    </label>
                    <input
                      type="text"
                      name="guardian_first_name"
                      id="guardian_first_name"
                      className="csame"
                      placeholder="Write guardian first name here..."
                      value={formData.guardian_first_name}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="type_1">
                    <label htmlFor="guardian_last_name" className="form-label">
                      Last Name
                    </label>
                    <input
                      type="text"
                      name="guardian_last_name"
                      id="guardian_last_name"
                      className="csame"
                      placeholder="Write guardian last name here..."
                      value={formData.guardian_last_name}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-inputs">
                  <div className="type_1">
                    <label htmlFor="guardian_job_title" className="form-label">
                      Job Title / Position
                    </label>
                    <input
                      type="text"
                      name="guardian_job_title"
                      id="guardian_job_title"
                      className="csame"
                      placeholder="Write job title here..."
                      value={formData.guardian_job_title}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="type_1">
                    <label htmlFor="guardian_telephone" className="form-label">
                      Telephone
                    </label>
                    <input
                      type="tel"
                      name="guardian_telephone"
                      id="guardian_telephone"
                      className="csame"
                      placeholder="Write guardian telephone here..."
                      value={formData.guardian_telephone}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-inputs">
                  <div className="type_1">
                    <label htmlFor="guardian_mobile" className="form-label">
                      Mobile
                    </label>
                    <input
                      type="tel"
                      name="guardian_mobile"
                      id="guardian_mobile"
                      className="csame"
                      placeholder="Write guardian mobile here..."
                      value={formData.guardian_mobile}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="type_1">
                    <label htmlFor="guardian_email" className="form-label">
                      Email
                    </label>
                    <input
                      type="email"
                      name="guardian_email"
                      id="guardian_email"
                      className="csame"
                      placeholder="Write guardian email here..."
                      value={formData.guardian_email}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="ak-height-40 ak-height-lg-30" />
              </div>
              {/* Preferable Course */}
              <div>
                <h3 className="contact-title ak-mb-20">Preferable Course</h3>
                <br />
                <div className="checkbox-grid ak-display-flex ak-flex-wrap ak-gap-15 ak-mb-20">
                  <label className="ak-display-flex ak-align-center ak-cursor-pointer">
                    <input
                      type="checkbox"
                      name="courses"
                      value="Mastery in Facilities Management"
                      className="ak-mr-10"
                      onChange={handleChange}
                    />{" "}
                    Mastery in Facilities Management
                  </label>
                  <br />
                  <label className="ak-display-flex ak-align-center ak-cursor-pointer">
                    <input
                      type="checkbox"
                      name="courses"
                      value="Management and Leadership"
                      className="ak-mr-10"
                      onChange={handleChange}
                    />{" "}
                    Management and Leadership
                  </label>
                  <br />
                  <label className="ak-display-flex ak-align-center ak-cursor-pointer">
                    <input
                      type="checkbox"
                      name="courses"
                      value="Facility Management Administration"
                      className="ak-mr-10"
                      onChange={handleChange}
                    />{" "}
                    Facility Management Administration
                  </label>
                  <br />
                  <label className="ak-display-flex ak-align-center ak-cursor-pointer">
                    <input
                      type="checkbox"
                      name="courses"
                      value="Project and Contract Management"
                      className="ak-mr-10"
                      onChange={handleChange}
                    />{" "}
                    Project and Contract Management
                  </label>
                  <br />
                  <label className="ak-display-flex ak-align-center ak-cursor-pointer">
                    <input
                      type="checkbox"
                      name="courses"
                      value="Facilities Operations & Maintenance Management"
                      className="ak-mr-10"
                      onChange={handleChange}
                    />{" "}
                    Facilities Operations & Maintenance Management
                  </label>
                  <br />
                  <label className="ak-display-flex ak-align-center ak-cursor-pointer">
                    <input
                      type="checkbox"
                      name="courses"
                      value="Procurement and Supply Chain"
                      className="ak-mr-10"
                      onChange={handleChange}
                    />{" "}
                    Procurement and Supply Chain
                  </label>
                  <br />
                  <label className="ak-display-flex ak-align-center ak-cursor-pointer">
                    <input
                      type="checkbox"
                      name="courses"
                      value="Certified Facility Manager (CFM)"
                      className="ak-mr-10"
                      onChange={handleChange}
                    />{" "}
                    Certified Facility Manager (CFM)
                  </label>
                  <br />
                  <label className="ak-display-flex ak-align-center ak-cursor-pointer">
                    <input
                      type="checkbox"
                      name="courses"
                      value="Administration and Office Management"
                      className="ak-mr-10"
                      onChange={handleChange}
                    />{" "}
                    Administration and Office Management
                  </label>
                  <br />
                  <label className="ak-display-flex ak-align-center ak-cursor-pointer">
                    <input
                      type="checkbox"
                      name="courses"
                      value="Sustainability Facility Professional (SFP)"
                      className="ak-mr-10"
                      onChange={handleChange}
                    />{" "}
                    Sustainability Facility Professional (SFP)
                  </label>
                  <br />
                  <label className="ak-display-flex ak-align-center ak-cursor-pointer">
                    <input
                      type="checkbox"
                      name="courses"
                      value="Soft Skills and Behavior Training"
                      className="ak-mr-10"
                      onChange={handleChange}
                    />{" "}
                    Soft Skills and Behavior Training
                  </label>
                  <br />
                  <label className="ak-display-flex ak-align-center ak-cursor-pointer">
                    <input
                      type="checkbox"
                      name="courses"
                      value="Certified Maintenance and Reliability Professional"
                      className="ak-mr-10"
                      onChange={handleChange}
                    />{" "}
                    Certified Maintenance and Reliability Professional
                  </label>
                  <br />
                  <div className="form-groupx ak-display-flex ak-flex-column ak-gap-10">
                    <label className="ak-display-flex ak-align-center ak-cursor-pointer">
                      <input
                        type="checkbox"
                        name="courses"
                        value="Other"
                        className="ak-mr-10"
                        onChange={handleChange}
                      />{" "}
                      Other
                    </label>
                    <br />
                    <input
                      type="text"
                      name="course_other_text"
                      className="csame"
                      placeholder="Specify other course"
                      value={formData.course_other_text}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              {/* Training Course Disclaimer and Student Agreement */}
              <div>
                <br />
                <h3 className="contact-title ak-mb-20">The Training Course Disclaimer and Student Agreement</h3>
                <div className="disclaimer-text ak-mb-20">
                  <br />
                  <p>
                    By enrolling in this IFM Edu Academy Private Limited program, you
                    acknowledge and agree that:
                  </p>
                  <br />
                  <h4 className="ak-font-16 ak-bold ak-mt-15">1. Limitation of Liability</h4>
                  <p>
                    1.1 While every effort is made to the accuracy and quality of the
                    training, IFM Edu Academy Private Limited disclaims any liability for
                    errors, omissions, or consequences arising from the application of
                    course material.
                  </p>
                  <p>
                    1.2 We are not responsible for any business loss, personal loss, exam
                    failure, or missed opportunities as a result of participating in our
                    training programs.
                  </p>
                  <br />
                  <h4 className="ak-font-16 ak-bold ak-mt-15">2. Disclaimer</h4>
                  <p>
                    2.1 IFM Edu Academy Private Limited is a professional management
                    training institution focused on skill development, career guidance,
                    exam preparations, evaluations, and academic excellence.
                  </p>
                  <p>
                    2.2 All course information is provided in good faith. Outcomes may vary
                    based on individual effort, market conditions, and third-party
                    examination or certification processes.
                  </p>
                  <p>
                    2.3 We do not provide legal or financial advice. Students are advised
                    to conduct their own due diligence.
                  </p>
                  <p>
                    2.4 Sharing, copying, publishing, distributing, or selling any course
                    material in whole or part is strictly prohibited.
                  </p>
                  <p>
                    2.5 Legal action will be initiated for any copyright infringement or
                    misuse of intellectual property.
                  </p>
                  <br />
                  <h4 className="ak-font-16 ak-bold ak-mt-15">3. Placement &amp; Career Support Policy</h4>
                  <p>
                    3.1 At IFM Edu Academy Private Limited, we are committed to empowering
                    our learners with the knowledge, skills, and guidance needed to pursue
                    rewarding career opportunities in their respective fields.
                  </p>
                  <p>
                    3.2 While we do not guarantee or commit to direct placement,
                    employment, internships, or recruitment, we strive to support our
                    participants through (1) career orientation and one-on-one guidance,
                    (2) professional resume and LinkedIn profile development, (3) interview
                    readiness and soft skills training, (4) access to relevant job portals,
                    industry networks, and hiring leads.
                  </p>
                  <p>
                    3.3 Our job is to facilitate career growth by enhancing candidate
                    preparedness and exposure. However, the outcome of job placement
                    depends entirely on the individual’s capability, effort, performance
                    in interviews, and the recruitment criteria of hiring organizations.
                  </p>
                  <p>
                    3.4 IFM Edu Academy shall not be held legally or financially
                    responsible for any hiring decisions, employment terms, salary
                    arrangements, or subsequent changes in employment status, including
                    termination or contractual disputes.
                  </p>
                  <p>
                    3.5 We encourage all candidates to conduct independent verification of
                    company profiles, job offers, and terms of employment prior to
                    accepting any opportunity.
                  </p>
                  <br />
                  <h4 className="ak-font-16 ak-bold ak-mt-15">4. Course Rescheduling or Cancellation</h4>
                  <p>
                    4.1 IFM Edu Academy Private Limited reserves the right to reschedule,
                    postpone, or cancel any course or session due to operational reasons,
                    force majeure events, or insufficient enrollment.
                  </p>
                  <br />
                  <h4 className="ak-font-16 ak-bold ak-mt-15">5. Force Majeure</h4>
                  <p>
                    5.1 IFM Edu Academy Private Limited shall not be held liable for any
                    delay or disruption of services due to circumstances beyond control,
                    including natural disasters, strikes, lockdowns, technical issues, or
                    government regulations.
                  </p>
                  <br />
                  <h4 className="ak-font-16 ak-bold ak-mt-15">6. Legal Jurisdiction</h4>
                  <p>
                    6.1 All matters, disputes, and legal issues shall be governed by the
                    laws of the Republic of India.
                  </p>
                  <p>
                    6.2 The jurisdiction for any legal proceedings shall be the courts
                    located in Kerala, India.
                  </p>
                  <br />
                  <h4 className="ak-font-16 ak-bold ak-mt-15">7. Enrollment &amp; Admission</h4>
                  <p>
                    7.1 Admission is granted solely at the discretion of IFM Edu Academy
                    based on eligibility criteria, availability, and verification of
                    required documents.
                  </p>
                  <p>
                    7.2 Submission of false or misleading information will lead to
                    disqualification from the course without any refund.
                  </p>
                  <br />
                  <h4 className="ak-font-16 ak-bold ak-mt-15">8. Fee Structure &amp; Payment Terms</h4>
                  <p>
                    8.1 Course fees are to be paid in full or through pre-approved
                    installment options.
                  </p>
                  <p>
                    8.2 Fees once paid are non-refundable and non-transferable under any
                    circumstances, unless a course is cancelled by IFM Edu Academy Private
                    Limited.
                  </p>
                  <p>
                    8.3 All fees are exclusive of GST and other applicable taxes as per
                    Indian tax laws.
                  </p>
                  <p>
                    8.4 Failure to complete payment as per schedule may result in
                    suspension of access to the course and LMS until dues are cleared.
                  </p>
                  <br />
                  <h4 className="ak-font-16 ak-bold ak-mt-15">9. Course Content &amp; Delivery</h4>
                  <p>
                    9.1 Programs may be conducted through physical classroom, virtual
                    classes, or Learning Management System (LMS) depending on the course
                    design.
                  </p>
                  <p>
                    9.2 Access to recorded content, downloadable resources, and additional
                    tools shall be provided for a fixed duration as communicated during
                    enrollment.
                  </p>
                  <p>
                    9.3 IFM Edu Academy Private Limited reserves the right to change
                    course structure, content, trainers, timing, and delivery mode without
                    prior notice, to maintain quality and relevance.
                  </p>
                  <br />
                  <h4 className="ak-font-16 ak-bold ak-mt-15">10. Certification Policy</h4>
                  <p>
                    10.1 Certification is awarded upon successful completion of the
                    program requirements including assignments, assessments, and
                    attendance.
                  </p>
                  <p>
                    10.2 Certificates from third-party or international bodies are
                    subject to fulfillment of their respective terms and may involve
                    additional requirements or fees (if applicable).
                  </p>
                  <p>
                    10.3 No certificate will be issued to candidates with pending dues or
                    disciplinary actions.
                  </p>
                  <br />
                  <h4 className="ak-font-16 ak-bold ak-mt-15">11. Conduct &amp; Discipline</h4>
                  <p>
                    11.1 Participants must maintain discipline, punctuality, and
                    professionalism throughout the course.
                  </p>
                  <p>
                    11.2 Harassment, abuse, discrimination, or misconduct toward peers,
                    faculty, or staff will result in immediate expulsion without refund.
                  </p>
                  <p>
                    11.3 Any form of cheating or plagiarism in assessment or assignment
                    will lead to disqualification from the course.
                  </p>
                  <br />
                  <h4 className="ak-font-16 ak-bold ak-mt-15">12. Intellectual Property</h4>
                  <p>
                    12.1 All training content, including but not limited to
                    presentations, manuals, videos, graphics, and assessments, is the
                    intellectual property of IFM Edu Academy Private Limited.
                  </p>
                </div>
              </div>
              {/* Declaration */}
              <div>
                <br />
                <h3 className="contact-title ak-mb-20">Declaration</h3>
                <div className="disclaimer-text ak-mb-20">
                  <p>
                    I agree to abide by the IFM Edu Academy Private Limited training
                    Service terms and conditions. I confirm that all the information
                    supplied in support of my application is correct and that by signing
                    this form constitutes a contractual membership agreement with the IFM
                    Edu Academy Private Limited.
                  </p>
                </div>
                <div className="form-inputs">
                  <div className="type_1">
                    <label htmlFor="date" className="form-label">
                      Date
                    </label>
                    <input
                      type="date"
                      name="date"
                      id="date"
                      className="csame"
                      value={formData.date}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="ak-height-40 ak-height-lg-40" />
              </div>
              <button type="submit" className="common-btn border-0">
                <span>Submit Application</span>
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={15}
                    height={15}
                    viewBox="0 0 15 15"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_201_978343789)">
                      <path
                        d="M1.42236 6.99728H13.089M13.089 6.99728L7.48903 1.39728M13.089 6.99728L7.48903 12.5973"
                        stroke="#030917"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_201_978343789">
                        <rect
                          width={14}
                          height={14}
                          fill="white"
                          transform="translate(0.00927734)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
              </button>
            </form>
          </div>
        </div>
      </div>
      {/* End Contact */}
      <Foot />
    </>
  );
}
export default Register;